import baseServices from "lib/BaseServices";
import RequestPattern from "./RequestPattern";

const patterns = [];

class Mock {
    GET(path, builder) {
        const p = new RequestPattern("GET", path, builder);
        patterns.push(p);
        return p;
    }

    PUT(path, builder) {
        const p = new RequestPattern("PUT", path, builder);
        patterns.push(p);
        return p;
    }

    POST(path, builder) {
        const p = new RequestPattern("POST", path, builder);
        patterns.push(p);
        return p;
    }

    DELETE(path, builder) {
        const p = new RequestPattern("DELETE", path, builder, url => url.replace(/^(.*)\.json$/, "$1.DELETE.json"));
        patterns.push(p);
        return p;
    }
}

const config = typeof window !== "undefined" && window !== null ? window.HybridConfig : undefined;
const mockRoot = config != null ? config.mockRoot : undefined;

if (mockRoot == null) {
    const msg = "To use API mocking, if you don't specify a mockset (e.g., 'ob-cath') on the URL, you must declare a 'mockRoot' config param (next to 'apiRoot' in config.js, probably like 'mocks/ob-cath/').";
    alert(msg);
    throw msg;
}

const apiRoot = baseServices.root_url;

// for fail-fast behaviour on a bad mockRoot
$.ajax(mockRoot + "/user.json?mock-fail-fast", {
    global: false,
    dataType: "json"
}).fail(() => alert(`No mockset was found at "${mockRoot}".`));

$(document).ajaxSend(function(e, jqXHR, config) {
    if (config.url.substr(0, apiRoot.length) === apiRoot) {
        jqXHR.mock = true;
        const path = config.url.substr(apiRoot.length - 1).split("?");
        const verb = config.type.toUpperCase();
        const req = verb + " " + path[0];
        const pattern = patterns.find(p => p.test(req));
        if (pattern == null) {
            const msg = `You have mocking enabled, but '${req}' isn't mocked.`;
            console.error(msg);
            jqXHR.abort(msg);
            return;
        }
        const newPath = pattern.build(req, config);
        if (newPath) {
            config.type = "GET"; // always gets when we're mocking
            path[0] = mockRoot + newPath.substring(1);
            config.url = path.join("?");
            if (pattern.hasDataFilter()) {
                config.dataFilter = pattern.getDataFilter(req, config);
            }
        } else {
            jqXHR.abort(e);
        }
    }
});

if (config.session != null) {
    console.log("Session management is disabled for Mock-based sessions.");
    config.session.autoLogout = false;
    config.session.keepAlive = false;
}

baseServices.endSession = function() {
    window.location.hash = "";
    window.location.reload(true);
};

baseServices.__mocked = true;

export default new Mock();



// WEBPACK FOOTER //
// ./test/mock/lib/Mock.js